import styled from '@emotion/styled'
import React, { useState } from 'react'
import { __legalDocumentType, __snackBarSeverity, __snackBarText } from '../../constants';
import mainContext from '../../contexts/mainContext';
import { getTermsAndConditionsController, addlegalDocumentController } from '../../Controllers/GeneralSettings';
import TextEditor from '../Common/TextEditor';

const TermsAndConditions = () => {
    const { setSnackBar, setProfileNavTitle } = React.useContext(mainContext);
    const [data, setData] = useState("");

    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    const getTermAndConditions = async () => {
        const res = await getTermsAndConditionsController();
        if (res && res.status === 500) {
            return callSnackBar(__snackBarText.internalServerError, "error")
        }
        if (res.data.status !== 200) {
            return callSnackBar(res.data.errors[0].message, "error");
        }
        setData(res.data.data?.termsConditions?.description);
    }

    const hanldeUpdate = async (newDesc) => {
        const res = await addlegalDocumentController({ type: __legalDocumentType.termsCondition, description: newDesc });
        
        if (res && res.status === 500) {
            return callSnackBar(__snackBarText.internalServerError, "error")
        }
        if (res.data.status !== 200) {
            return callSnackBar(res.data.errors[0].message, "error");
        }
        return callSnackBar("Data updated successfully", "success")
    }

    React.useEffect(() => {
        getTermAndConditions();
        setProfileNavTitle("Terms and conditions");
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <Container>
                <TextEditor data={data} hanldeUpdate={hanldeUpdate} />
            </Container>
        </>
    )
}

const Container = styled("div")`
    margin-top: 1rem;
    padding-right: 3rem;
`;
export default TermsAndConditions